import { TagSchema } from "@redotech/redo-common-model/tag";
import { FulfillmentGroupDataSchema } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import {
  CreateFulfillmentOrderSchema,
  type ICreateFulfillmentOrder,
} from "@redotech/redo-model/fulfillments/create-fulfillment-order";
import * as z from "zod";

export const createManualFulfillmentGroups = {
  name: "createManualFulfillmentGroups" as const,
  input: z.object({
    fulfillmentOrders: z.array(
      CreateFulfillmentOrderSchema as ICreateFulfillmentOrder,
    ),
    shipmentTags: z.array(TagSchema).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    fulfillmentGroups: z.array(FulfillmentGroupDataSchema).nullish(),
  }),
};
